const InteractiveMap = function($selector) {
	const module = {
		opts: {
			$module: $selector,
			styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#7c93a3"},{"lightness":"-10"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#a0a4a5"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#62838e"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#e9f0f6"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#3f4a51"},{"weight":"0.30"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#bbcacf"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"0"},{"color":"#bbcacf"},{"weight":"0.50"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#a9b4b8"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"invert_lightness":true},{"saturation":"-7"},{"lightness":"3"},{"gamma":"1.80"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#bed0de"}]}],
			selectors: {}
		},
		map: {},
		bindEvents: function() {},
		init: function() {
			this.map = this.initMap();
			this.initMarkers();
			this.centerMap();
		},
		initMap: function() {
			const { $module, styles } = this.opts;
			const map = new google.maps.Map( $module[0], {
				zoom : $module.data('zoom') || 4,
				mapTypeId : 'roadmap', // google.maps.MapTypeId.ROADMAP,
				center: { lat: -25.344, lng: 131.031 },
				disableDefaultUI: true,
				styles
			});
			return map;
		},
		initMarkers: function() {
			this.map.markers = [];
			this.opts.$module.data('markers').forEach(marker => this.addMarker(marker));
		},
		addMarker: function(data) {
			const marker = new google.maps.Marker({
				position: {
					lat: parseFloat( data['lat'] ),
					lng: parseFloat( data['lng'] )
				},
				icon: '/wp-content/themes/trimark-framework/dist/images/icons/icon-pin.svg',
				map: this.map
			});

			// Append to reference for later use.
			this.map.markers.push( marker );

			// If marker contains HTML, add it to an infoWindow.
			if( data.name.length ){

				// Create info window.
				const infowindow = new google.maps.InfoWindow({
					content: data.name
				});

				// Show info window when marker is clicked.
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open( this.map, marker );
				});
			}
		},
		centerMap: function() {
			const bounds = new google.maps.LatLngBounds();
			this.map.markers.forEach(function( marker ){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});

			// Case: Single marker.
			if( this.map.markers.length == 1 ){
				this.map.setCenter( bounds.getCenter() );

			// Case: Multiple markers.
			} else{
				this.map.fitBounds( bounds );
			}
		}
	}

	if ($selector.length && typeof google !== 'undefined') {
		module.init();
	}

	return module;
}


/**
 * Register after jQuery doc ready
 */
$(() => {
	new InteractiveMap($('.map-element'));
});
